export const list = [
  { id: 1, name: "Complete" },
  { id: 2, name: "Refunded" },
  
];

